import React from "react";
import classNames from "classnames";
import { Text, TextProps } from "@jsq/ds/core";
import { Icon, IconType, IconVariant } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { iconStyle, textStyle } from "./styles_vanilla.css";

export type TextWithIconProps = {
  iconType?: IconType;
  labelColor?: Colors;
  iconColor?: Colors;
  iconVariant?: IconVariant;
  label: string;
  className?: string;
  textVariant?: TextProps["variant"];
};

/**
 * Used to display a text prefix with icon.
 * Eg: (i) Processing, with their respective icons
 */
export const TextWithIcon: React.FC<TextWithIconProps> = (props: TextWithIconProps) => {
  const {
    className,
    iconType,
    label,
    labelColor = Colors.Neutral800,
    iconColor = Colors.Neutral800,
    iconVariant,
    textVariant,
  } = props;
  return (
    <Text
      variant={textVariant}
      className={classNames(textStyle, className)}
      style={{ color: labelColor }}
    >
      {iconType && (
        <Icon type={iconType} color={iconColor} variant={iconVariant} className={iconStyle} />
      )}
      {label}
    </Text>
  );
};
